// =====================================================
// RAZORPAY CHECKOUT BRANDING
//
// The one name + logo every Razorpay checkout in the app shows (Pro
// membership, Pro creator access, Boost, Love leaderboard, Premium badge).
//
// WHY THE LOGO URL IS ABSOLUTE
//   Razorpay renders checkout inside an iframe on its OWN domain, so a relative
//   path like "/logo192.png" resolves against api.razorpay.com, 404s, and the
//   modal silently falls back to showing only the name. The image must be a
//   full https URL.
//
// WHY LOCALHOST USES THE PRODUCTION COPY
//   On http://localhost an http logo inside Razorpay's https iframe is mixed
//   content and is blocked, so development points at the deployed file.
// =====================================================

const PRODUCTION_ORIGIN = "https://theblogssphere.com";

const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const origin =
  typeof window === "undefined" || isLocalhost || window.location.protocol !== "https:"
    ? PRODUCTION_ORIGIN
    : window.location.origin;

export const RAZORPAY_BRAND = {
  name: "TheBlogsSphere",
  image: `${origin}/razorpay-logo.png`,
};
